import get from 'lodash/get';

export const selectTourFinished = (state) => get(state, 'preferences.tourFinished', false);

export const selectNewTourFinished = (state, tourSection) => get(state, `preferences.${tourSection}`, false);

export const selectShowNewTour = (state) => get(state, 'preferences.showNewTour', false);
